import gql from 'graphql-tag'
import client, { accessToken } from '@stores/apollo'

interface IProps {
  file: string
  mapping?: any
}

export interface IOperationCostImportResult {
  createdAt: Date
  createdCount: number
  failedCount: number
  id: string
  importedBy: string
  status: string
  totalCount: number
  updatedCount: number
  url: string
}

export interface IProjectionImportResult {
  createdAt: Date
  createdCount: number
  failedCount: number
  id: string
  importedBy: string
  status: string
  totalCount: number
  updatedCount: number
  url: string
}

export default async function upload({ file, mapping }: IProps, type: string) {
  const formData = new FormData()
  formData.append('import[file]', file)
  formData.append('import[async]', 'true')
  formData.append('import[import_type]', type)
  formData.append('access_token', accessToken)
  const { importId } = await fetch(`${window.graphqlEndpoint}/imports`, {
    method: 'POST',
    body: formData,
  }).then((response) => response.json())
  return await new Promise<IImportResult>((resolve, reject) => {
    const checkIt = () => {
      return client.gql
        .query({ query: progressQuery, variables: { importId } })
        .then(({ data: { node } }: Payload) => {
          if (node.status === 'completed' || node.status === 'failed') return resolve(node)
          window.setTimeout(checkIt, 1000)
        })
    }
    checkIt()
  })
}

export interface IEmployeeImportResult {
  id: string
  status: string
  progress: {
    progress: string
    total: string
  }
}

interface IBookingImportResult {
  id: string
  status: string
  createdAt: Date
  url: string
  totalCount: number
  createdCount: number
  failedCount: number
}

interface INeighborhoodImportResult {
  id: string
  status: string
  createdAt: Date
  url: string
  totalCount: number
  createdCount: number
  failedCount: number
}

export type IImportResult =
  | IEmployeeImportResult
  | IOperationCostImportResult
  | IProjectionImportResult
  | IBookingImportResult
  | INeighborhoodImportResult

interface Payload {
  data: {
    node: IImportResult
  }
}

const progressQuery = gql`
  query ($importId: ID!) {
    node(id: $importId) {
      id
      ... on EmployeeImport {
        status
        progress {
          progress
          total
        }
      }
      ... on BookingImport {
        status
        createdAt
        url
        totalCount
        createdCount
        failedCount
      }
      ... on OperationCostImport {
        status
        createdAt
        url
        totalCount
        createdCount
        updatedCount
        failedCount
      }
      ... on ProjectionImport {
        status
        createdAt
        url
        totalCount
        updatedCount
        createdCount
        failedCount
      }
      ... on BuildingImport {
        status
        createdAt
        url
        totalCount
        updatedCount
        createdCount
        failedCount
      }
      ... on FloorImport {
        status
        createdAt
        url
        totalCount
        updatedCount
        createdCount
        failedCount
      }
      ... on LeaseImport {
        status
        createdAt
        url
        totalCount
        createdCount
        failedCount
      }
      ... on EmployeesNeighborhoodsImport {
        status
        createdAt
        url
        totalCount
        createdCount
        failedCount
      }
      ... on EmployeesTagsImport {
        status
        createdAt
        url
        totalCount
        createdCount
        failedCount
      }
      ... on SpacesTagsImport {
        status
        createdAt
        url
        totalCount
        createdCount
        failedCount
      }
    }
  }
`
